/** Viewport height reserved so tall elements scroll to their top instead of centering. */
export const COPILOT_SCROLL_VIEWPORT_MARGIN_PX = 100

/**
 * Scrolls a page element into view for copilot highlight/focus.
 *
 * Centers elements that fit in the viewport (minus a margin). Tall elements
 * (e.g. large tables) scroll so their top is visible instead of centering mid-content.
 */
export const scrollCopilotElementIntoView = (element: HTMLElement): void => {
  const availableViewportHeight = window.innerHeight - COPILOT_SCROLL_VIEWPORT_MARGIN_PX
  const isTallerThanViewport = element.getBoundingClientRect().height > availableViewportHeight

  element.scrollIntoView({
    behavior: 'smooth',
    block: isTallerThanViewport ? 'start' : 'center',
    inline: 'nearest'
  })
}
